import { render, staticRenderFns } from "./DiyList.vue?vue&type=template&id=fc9d6bb2&scoped=true&"
import script from "./DiyList.vue?vue&type=script&lang=js&"
export * from "./DiyList.vue?vue&type=script&lang=js&"
import style0 from "./DiyList.vue?vue&type=style&index=0&id=fc9d6bb2&lang=scss&scoped=true&"
import style1 from "./DiyList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc9d6bb2",
  null
  
)

export default component.exports